export default __webpack_public_path__ + "protected-area-800-3cb660819c56ff972cf712e1ab5f99a1.png";